import { createRef, useContext, useEffect, useState } from "react";
import { IsNullOrEmpty, IsValidEmail } from "../../core/utility";
import { post } from "../../core/client";
import { useParams } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";

import makeStyles from "@mui/styles/makeStyles";
import Grid from "@mui/material/Grid";
import Input from "../../components/inputs/text-field-input";
import PhoneInput from "../../components/inputs/phone";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import { CustomButton } from "../../components/buttons";
import { KS_MEMBER_TYPES } from "../../core/consts";
import CircularProgress from "@mui/material/CircularProgress";
import JoinFormUndeageContextProvider, { JoinFormUndeageContext, LegalContractConsentType } from "../shared/JoinFormUndeageContext";
import reactStringReplace from "react-string-replace";
import JoinModal from "./Modal";

const useStyles = makeStyles({

    form: {
        display: 'block',
        marginBottom: 20
    },
    icon: {
        display: 'block',
        fontSize: 100,
        textAlign: 'center',
        marginBottom: 20
    },
    aside: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    },
    successText: {
        fontSize: 20,
        textAlign: 'center'
    },
    errorCheckbox: {
        color: 'red'
    }
});

interface InputErrorModel {
    name: string;
    errorText: string;
}

interface RouteParams {
    comApprovePrivateNo?: string;
}

interface StateModel {
    tcIdentityNo: string;
    firstName: string;
    lastName: string;
    workMail: string;
    personalMail: string;
    mobilePhone: string;
    reCaptchaToken: string;
    memberTypeId: number;
    //kişisel veri paylaşım izni
    approvedConsents: Array<string>
}

const initialState: StateModel = {
    tcIdentityNo: "",
    firstName: "",
    lastName: "",
    workMail: "",
    personalMail: "",
    mobilePhone: "",
    reCaptchaToken: "",
    memberTypeId: -1,
    approvedConsents: []
};

const JoinFormUnderAgeComponent = () => {

    const { legalTextLoading, legalTexts, loadLegalTexts, openLegalTextModal } = useContext(JoinFormUndeageContext);

    const recaptchaRef = createRef<any>();

    const classes = useStyles();
    let routeParams: RouteParams = useParams();
    const comApprovePrivateNo = routeParams.comApprovePrivateNo ? routeParams.comApprovePrivateNo : null;

    const [state, setState] = useState<StateModel>(initialState);
    const [loading, setLoading] = useState<boolean>(false);
    const [sendLoading, setSendLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string>("");
    const [validationMessage, setValidationMessage] = useState<string>("");
    const [inputErrors, setInputErrors] = useState<Array<InputErrorModel>>([]);
    const [showCampaignMessagePermModal, setShowCampaignMessagePermModal] = useState(false);
    const [isRead, setIsRead] = useState<boolean>(false);
    const [isKvkkError, setIsKvkkError] = useState(false);

    useEffect(() => {
        if (!IsNullOrEmpty(comApprovePrivateNo)) {
            loadMemberInfos(comApprovePrivateNo as string);
            loadLegalTexts([
                LegalContractConsentType.VERI_IZNI,
                LegalContractConsentType.YKB_VERI_AKTARIM_IZNI,
                LegalContractConsentType.ETK_IZNI,
                LegalContractConsentType.YURT_DISI_VERI_IZNI,
                LegalContractConsentType.UYELIK_SOZLESMESI,
                LegalContractConsentType.YKB_AYDINLATMA

            ])
        }
    }, [comApprovePrivateNo]);

    const loadMemberInfos = async (comApprovePrivateNo: string) => {
        setLoading(true);
        const request = {
            CommAppLinkNo: comApprovePrivateNo
        }
        const { data, fail, errorMessage } = await post<any>('api/membership/get-member-info', request);
        setLoading(false);
        if (data) {
            if (data.preControlSuccess) {
                setErrorMessage(data.preControlErrMessage);
                return;
            }
            setState(prev => ({
                ...prev,
                tcIdentityNo: data.tcIdentityNo,
                firstName: data.firstName,
                lastName: data.lastName,
                personalMail: data.personalMail,
                mobilePhone: data.mobilePhone,
                workMail: data.workMail,
                memberTypeId: data.memberTypeId
            }));
        } else {
            setErrorMessage("Geçersiz link.");
        }
    }

    const handleChange = (e: any) => {
        setState(prev => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    }

    const openCampaignMessagePermModal = () => {
        setShowCampaignMessagePermModal(true);
        setIsRead(true);
    };

    const handleCampaignMessagePermResponse = (value: boolean) => {
        if (value && !isConsentApproved(LegalContractConsentType.ETK_IZNI)) {

            setState(prev => ({
                ...prev,
                approvedConsents: [...state.approvedConsents, LegalContractConsentType.ETK_IZNI],
            }));
        }
    }

    const handleMembershipAggreement = () => {
        openLegalTextModal(LegalContractConsentType.UYELIK_SOZLESMESI);
    }
    const handleYkbAggreement = () => {
        openLegalTextModal(LegalContractConsentType.YKB_AYDINLATMA);
    }

    const handleConsentCheckbox = (e: any) => {
        const consentType = e.target.name;
        let consents: Array<string> = [...state.approvedConsents];
        consents = consents.filter(x => x !== consentType);

        if (e.target.checked) {
            consents = [...consents, consentType];

            if (consentType === LegalContractConsentType.VERI_IZNI
                || consentType === LegalContractConsentType.YURT_DISI_VERI_IZNI
                || consentType === LegalContractConsentType.VAKIF_DERNEK_IZNI
            ) {
             
                openLegalTextModal(consentType as LegalContractConsentType);
            }
        }
        setState(prev => ({
            ...prev,
            approvedConsents: consents,
        }));
    }
    const isConsentApproved = (type: string) => {
        return state.approvedConsents.some(consent => consent === type);
    }

    const isRequiredConsentsChecked = (model: StateModel) => {
        const requiredConsents = legalTexts?.consents.filter(x => x.required
            && x.type !== LegalContractConsentType.UYELIK_SOZLESMESI
            && x.type !== LegalContractConsentType.YKB_AYDINLATMA);
        if (requiredConsents) {

            for (let item of requiredConsents) {

                if (item.type === LegalContractConsentType.VAKIF_DERNEK_IZNI
                    && (model.memberTypeId !== KS_MEMBER_TYPES.KU_MEZUN || model.memberTypeId !== KS_MEMBER_TYPES.EMEKLI)) continue;

                if (!isConsentApproved(item.type)) {
                    return;
                }
            }
        }
        return true;
    }

    const onChangeCaptcha = async (e: any) => {
        setState(prev => ({
            ...prev,
            reCaptchaToken: e
        }));
    }

    const resetCaptcha = () => {
        if (IsNullOrEmpty(state.reCaptchaToken)) return;
        setState(prev => ({ ...prev, reCaptchaToken: '' }));
        (window as any).grecaptcha.reset();
    }

    const handleSend = async (model: StateModel) => {

        if (!validate(model)) {
            resetCaptcha();
            return;
        }

        setSendLoading(true);
        const request = {
            privateLinkNo: comApprovePrivateNo,
            tcIdentityNo: model.tcIdentityNo,
            firstName: model.firstName,
            lastName: model.lastName,
            mobilePhone: model.mobilePhone.toString(),
            workEmail: model.workMail,
            personalEmail: model.personalMail,
            isApprovedVeriIzni: isConsentApproved(LegalContractConsentType.VERI_IZNI),
            isApprovedYkbAktarim: isConsentApproved(LegalContractConsentType.YKB_VERI_AKTARIM_IZNI),
            commPermission: isConsentApproved(LegalContractConsentType.ETK_IZNI),
            reCaptchaToken: model.reCaptchaToken
        }
        const { data, fail, errorMessage } = await post<any>('api/membership/join-all-comm-app', request);
        setSendLoading(false);
        if (data) {
            if (data.resultCode === '1') {
                window.location.href = "/join-form/success";
            }
            else {
                setValidationMessage(data.description);
            }
        }

        resetCaptcha();
    }

    const setError = (name: keyof StateModel, errorText = 'Zorunlu alan') => {
        const error: InputErrorModel = { name, errorText };
        setInputErrors((prev: Array<InputErrorModel>) => [...prev, error]);
    }

    const validate = (model: StateModel) => {
        setValidationMessage("");
        setInputErrors([]);
        setIsKvkkError(false);

        let isValid = true;

        if (IsNullOrEmpty(model.mobilePhone)) {
            setError('mobilePhone', 'Geçerli bir telofon numarası giriniz');
            isValid = false;
        }
        if (model.memberTypeId === KS_MEMBER_TYPES.CALISAN || model.memberTypeId === KS_MEMBER_TYPES.DIGER) {
            if (IsNullOrEmpty(model.workMail) || !IsValidEmail(model.workMail)) {
                setError('workMail', 'Geçerli bir e-posta adresi giriniz');
                isValid = false;
            }
        }
        else {
            if (IsNullOrEmpty(model.personalMail) || !IsValidEmail(model.personalMail)) {
                setError('personalMail', 'Geçerli bir e-posta adresi giriniz');
                isValid = false;
            }
        }
        if (!IsNullOrEmpty(model.personalMail) && !IsNullOrEmpty(model.workMail)) {
            if (model.personalMail === model.workMail) {
                setValidationMessage("İş ve kişisel Email adresleri aynı olamaz");
                return false;
            }
        }

        if (!isValid) {
            setValidationMessage("Zorunlu alanları kontrol ediniz.");
            return;
        }

        if (!isRequiredConsentsChecked(model)) {
            setIsKvkkError(true);
            return false;
        }

        if (!isConsentApproved(LegalContractConsentType.ETK_IZNI) && !isRead) {
            openCampaignMessagePermModal();
            isValid = false;
        }

        if (isValid && IsNullOrEmpty(model.reCaptchaToken)) {
            setValidationMessage("Robot doğrulamasını yapmalısınız.");
            return;
        }

        return isValid;
    }

    return (

        loading || legalTextLoading ? (
            <Box display="flex" justifyContent="center" flexDirection="column" alignItems="center" paddingY={2}>
                <p>Lütfen bekleyiniz...</p>
                <CircularProgress />
            </Box>
        ) : (
            <div className={classes.aside}>
                <div className={classes.form}>
                    <Grid container spacing={2}>
                        <Grid item sm={6} xs={12}>
                            <Input
                                id="firstName"
                                name="firstName"
                                caption="Ad"
                                className="mb-1"
                                onChange={handleChange}
                                value={state.firstName}
                                readOnly={true}
                            />
                        </Grid>
                        <Grid item sm={6} xs={12}>
                            <Input
                                id="lastName"
                                name="lastName"
                                caption="Soyad"
                                className="mb-1"
                                onChange={handleChange}
                                value={state.lastName}
                                readOnly={true}
                            />
                        </Grid>
                        <Grid item sm={6} xs={12}>
                            <Input
                                id="tcIdentityNo"
                                name="tcIdentityNo"
                                caption="Tc Kimlik No"
                                className="mb-1"
                                onChange={handleChange}
                                value={state.tcIdentityNo}
                                readOnly={true}
                            />
                        </Grid>
                        <Grid item sm={6} xs={12}>
                            <PhoneInput
                                id="mobilePhone"
                                name="mobilePhone"
                                caption="Cep Telefonu"
                                className="mb-1"
                                value={state.mobilePhone}
                                onChange={handleChange}
                                errorText={inputErrors.find(x => x.name === 'mobilePhone')?.errorText}
                            />
                        </Grid>
                        <Grid item sm={6} xs={12}>
                            <Input
                                id="personalMail"
                                name="personalMail"
                                caption="Kişisel Email Adresi"
                                className="mb-1"
                                onChange={handleChange}
                                value={state.personalMail}
                                errorText={inputErrors.find(x => x.name === 'personalMail')?.errorText}
                            />
                        </Grid>
                        <Grid item sm={6} xs={12}>
                            <Input
                                id="workMail"
                                name="workMail"
                                caption="İş Email Adresi"
                                className="mb-1"
                                onChange={handleChange}
                                value={state.workMail}
                                errorText={inputErrors.find(x => x.name === 'workMail')?.errorText}
                            />
                        </Grid>
                    </Grid>

                    <div className="py-3">
                        {legalTexts?.consents.filter(x =>
                            x.type !== LegalContractConsentType.UYELIK_SOZLESMESI
                            && x.type !== LegalContractConsentType.YKB_AYDINLATMA).map((item, index) => (
                                <div className="py-1" key={index}>
                                    <FormControlLabel
                                        control={<Checkbox
                                            name={item.type} color="primary"
                                            checked={isConsentApproved(item.type)}
                                            onChange={handleConsentCheckbox}
                                        />}
                                        label={
                                            <div className={item.required && isKvkkError && !isConsentApproved(item.type) ?
                                                `${classes.errorCheckbox}` : ''} dangerouslySetInnerHTML={{ __html: item.text }}></div>
                                        }
                                    />
                                </div>
                            ))}
                    </div>
                    <Box display="flex" justifyContent="center" marginBottom={2}>
                        <ReCAPTCHA
                            ref={recaptchaRef}
                            sitekey="6LdqH0QfAAAAAAQR10C9Poo7LItjCQ0Fbe2l9Fnn"
                            onChange={onChangeCaptcha}
                        />
                    </Box>
                    <Box marginBottom={2} textAlign="center">
                        {
                            reactStringReplace(
                                legalTexts?.consents.find(x => x.type === LegalContractConsentType.YKB_AYDINLATMA)?.text ?? '',
                                /<strong>(.*?)<\/strong>/,
                                (match, i) => (
                                    <button
                                        style={{ color: '#177897', cursor: 'pointer', border: 'none' }}
                                        onClick={handleYkbAggreement}>
                                        <strong>{match}</strong></button>
                                ))
                        }
                    </Box>
                    <Box marginBottom={2} textAlign="center">
                        'Onaylıyorum' butonuna basılması ile <button style={{ color: '#177897', cursor: 'pointer', border: 'none' }} onClick={handleMembershipAggreement}><strong>Üyelik Sözleşmesi</strong></button>'ni okuduğunuzu ve kabul ettiğinizi onaylıyorsunuz.
                    </Box>
                    <Box display="flex" justifyContent="center">
                        <CustomButton
                            text="Onaylıyorum"
                            className="btn-primary"
                            disabled={sendLoading || !IsNullOrEmpty(errorMessage)}
                            loading={sendLoading}
                            onClick={() => handleSend(state)} />
                    </Box>
                </div>

                <JoinModal
                    show={showCampaignMessagePermModal}
                    onClose={() => setShowCampaignMessagePermModal(false)}
                    onPermission={handleCampaignMessagePermResponse}
                />

                {!IsNullOrEmpty(validationMessage) && (
                    <Alert severity="error" className="mb-2">{validationMessage}</Alert>
                )}

                {!IsNullOrEmpty(errorMessage) && (
                    <Alert severity="error" className="mb-2">{errorMessage}</Alert>
                )}
            </div>
        )
    )
}

const JoinFormUnderAge = () => (
    <JoinFormUndeageContextProvider>
        <JoinFormUnderAgeComponent />
    </JoinFormUndeageContextProvider>
);

export default JoinFormUnderAge;